<template>
  <VDialogV3
    width="600px"
    height="100vh"
    position="right"
    :loading="false"
    hide-footer
    title="Добавление единиц измерения"
  >

    <VDataGridV2
      layout="fill"
      :loader="dataLoader"
      @row:click="(row) => handleUnits(row)"
    >
      <VDataGridColumnV2
        id="id"
        label="ID"
        width="60px"
      />

      <VDataGridColumnV2
        id="name"
        label="Название"
      />

      <VDataGridColumnV2
        id="action"
        width="48px"
      >
        <template #default="{ row }">
          <VButton
            v-if="allowedUnitsIds.has(row.id)"
            :key="'delete_' + row.id"
            :disabled="isLoading"
            @click="detachUnit(row)"
          >
            <template #icon>
              <VIcon material="delete"/>
            </template>
          </VButton>

          <VButton
            v-else
            :key="'add_' + row.id"
            theme="primary"
            :disabled="isLoading"
            @click="attachUnit(row)"
          >
            <template #icon>
              <VIcon material="add"/>
            </template>
          </VButton>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </VDialogV3>
</template>

<script lang="ts">

import DataGridLoader  from '@/lib/components/VDataGridV2/DataGridLoader';
import UnitsService    from '@/domains/Units/UnitsService';
import ProductCategory from '@/domains/ProductCategories/ProductCategory';
import GlobalLoader    from "@/core/services/GlobalLoader/GlobalLoader";

export default defineComponent({
	name: 'ProductCategoryAllowedUnitsDialog',

	props: {
		productCategory: {
			type:    Object,
			default: null,
		},
	},

	emits: [ProductCategory.Events.AttachUnit, ProductCategory.Events.DetachUnit],

	data() {
		return {
			allowedUnitsIds: new Set(this.productCategory.allowedUnits.map((item: any) => item.id)),
			dataLoader:      new DataGridLoader(UnitsService.getListPaginated.bind(UnitsService)),
		};
	},

	computed: {
		/** Режим создания (категория ещё не сохранена) — мутируем напрямую, без emit */
		createMode(): boolean {
			return Boolean(!this.productCategory.id);
		},

		/** Имеется ли у категории список разрешённых единиц измерения */
		haveAllowedUnits(): boolean {
			return (
				this.$core.utils.isObject(this.productCategory)
				&& Array.isArray(this.productCategory.allowedUnits)
				&& this.productCategory.allowedUnits.length > 0
			);
		},

		/** Список разрешённых единиц у текущей категории */
		allowedUnits(): any[] {
			return this.haveAllowedUnits ? this.productCategory.allowedUnits : [];
		},

		isLoading(): boolean {
      return GlobalLoader.isVisible;
		},
	},

	methods: {
		/**
		 * Обработка клика по строке — переключает привязку единицы к категории
		 */
		handleUnits(unit: any): void {
			if (this.isLoading) return;

			if (this.allowedUnitsIds.has(unit.id)) {
				this.detachUnit(unit);
			} else {
				this.attachUnit(unit);
			}
		},

		/**
		 * Привязать единицу измерения к категории
		 */
		attachUnit(unit: any): void {
			this.allowedUnitsIds.add(unit.id);

			if (this.createMode) {
				this.productCategory.attachUnit(unit);
				return;
			}

			this.$emit(ProductCategory.Events.AttachUnit, unit);
		},

		/**
		 * Отвязать единицу измерения от категории. У опубликованной категории
		 * нельзя оставить меньше одной единицы — на это бросается уведомление.
		 */
		detachUnit(unit: any): void {
			if (this.productCategory.isPublished && this.allowedUnits.length < 2) {
				this.$core.showNotification.error('Нельзя удалить все единицы измерения у опубликованного товара');
				return;
			}

			this.allowedUnitsIds.delete(unit.id);

			if (this.createMode) {
				this.productCategory.detachUnit(unit);
				return;
			}

			this.$emit(ProductCategory.Events.DetachUnit, unit);
		},
	},
});
</script>
